export const WebhookHookSummaryComponent = {
  template: "<small>{{$ctrl.hook.config.url}}</small>",
  bindings: {
    hook: "<",
  },
  controller: class WebhookHookSummaryComponent {
    $onInit() {}
  },
};
